<template>
  <v-app-bar id="tr-header" app dense color="white" v-if="isInitialized" height="83">
    <v-app-bar-nav-icon color="primary" v-if="isAdministrator" @click="$emit('toggle')"></v-app-bar-nav-icon>
    <v-toolbar-title class="font-weight-bold primary--text" v-if="isAdministrator">{{ $route.meta.title }}</v-toolbar-title>
    <v-img src="../../assets/tr-logo-long.png" alt="Argo Time Report" height="56" position="center left" contain v-else></v-img>
    <v-spacer></v-spacer>
    <v-img src="../../assets/argo.png" alt="Argo Software" contain position="center right" height="32"></v-img>
    <v-btn icon color="primary" :href="manualUrl" target="_blank"><v-icon>mdi-help-circle</v-icon></v-btn>
    <v-divider vertical inset class="mx-4"></v-divider>
    <v-menu v-model="loggedMenu" :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn fab color="primary" elevation="3" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-card width="374px">
        <v-list-item three-line class="cyan">
          <v-list-item-content>
            <v-list-item-title class="title font-weight-bold white--text">{{ user.fullName }}</v-list-item-title>
            <v-list-item-subtitle class="caption font-weight-medium white--text">{{ user.username }}</v-list-item-subtitle>
            <span>  
              <v-chip small color="white" text-color="cyan" v-if="isAdministrator">
                <v-avatar left><v-icon small color="cyan">mdi-star</v-icon></v-avatar>
                Amministratore
              </v-chip>
              <v-chip small color="white" text-color="cyan" v-else>
                <v-avatar left><v-icon small color="cyan">mdi-account</v-icon></v-avatar>
                Operatore
              </v-chip>
            </span>
          </v-list-item-content>
          <v-list-item-avatar size="80" color="white">
            <div class="cyan--text font-weight-bold" style="font-size: 24px; width: 100%;">{{ avatar }}</div>
          </v-list-item-avatar>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="title font-weight-bold primary--text">{{ customer.description }} {{ customer.name }}</v-list-item-title>
            <v-list-item-subtitle class="caption font-weight-medium primary--text">{{ customer.address }}, {{ customer.city }} ({{ customer.district }}) &mdash; {{ customer.postalCode }}</v-list-item-subtitle>
            <span>  
              <v-chip small >
                <v-avatar left><v-icon small color="primary">mdi-office-building</v-icon></v-avatar>
                {{ customer.codMin }}
              </v-chip>
            </span>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small color="red" @click="$emit('signout')">Esci dall'applicazione</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
moment.locale('it');

export default {
  name: 'RgHeader',

  data: ()=> ({
    loggedMenu: false, // apre/chiude il menu contenente la sessione loggata.,
    manualUrl: process.env.VUE_APP_CLIENT_MANUAL_URL,
  }),

  computed: {
    ...mapGetters('argoStore', [ 'isInitialized', 'isAdministrator', 'user', 'customer', 'expireAt' ]),
    ...mapGetters('oidcStore', [ 'oidcIdTokenExp' ]),

    avatar(){
      return (this.user.name && this.user.surname) ? `${this.user.name.charAt(0).toUpperCase()}${this.user.surname.charAt(0).toUpperCase()}` : '';
    }
  },

  methods: {
    ...mapActions('oidcStore', [ 'signOutOidc' ]),
  }
}
</script>